import React from 'react';

import { StatisticsSection } from 'components/StatisticksComponents/StatisticsSection/StatisticsSection';

export const StatisticsPage = () => {
  return (
    <div>
      <StatisticsSection />
    </div>
  );
};
